/**
 * Small pieces the /looker app boxes share: the empty-state line and the
 * "—" every null figure renders as (null is "not measurable", never 0).
 *
 * @module components/looker/app/appBoxShared
 */
import React from 'react';

export const DASH = '—';

export const BoxMessage: React.FC<{ text: string }> = ({ text }) => (
  <p className="py-6 text-center text-sm text-neutral-700">{text}</p>
);

/** A box that failed to load: an alert in error colour, never mistakable for an empty box. */
export const BoxError: React.FC<{ text: string }> = ({ text }) => (
  <p role="alert" className="py-6 text-center text-sm font-medium text-error-700">{text}</p>
);
